
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service-agreement",
      function () {
        return require("private-next-pages/service-agreement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service-agreement"])
      });
    }
  